import { render, staticRenderFns } from "./SvgMatrix.vue?vue&type=template&id=9296a2c8"
import script from "./SvgMatrix.vue?vue&type=script&lang=js"
export * from "./SvgMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports